
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  HqPackingList,
  CustomsPackingSet,
  UnpackedProductInfos,
} from "@/model/inventory-plan";
import { queryProductInfos, updateProductQuantity } from "@/api/customs-packing";
import { deleteInventoryPlans } from "@/api/inventory-plan";
import { isEmpty, toUpper } from "lodash";
import { LoadingPlanType } from "@/views/sales-management/SalesBookingOrderManagement.vue";
import ProductTable from "./ProductTable.vue";
import HistoryProblem from "./HistoryProblem.vue";
import Template from "@/views/system-management/template/index.vue";

/**
 * 盘库详情
 */
@Component({
  name: "InventoryTable",
  components: {
    Template,
    ProductTable,
    HistoryProblem,
  },
})
export default class extends Vue {
  @Prop({ required: true }) private data: HqPackingList;
  @Prop({ required: false, default: false }) private useInvoiceMoney: boolean;
  @Prop({ required: false, default: false }) private code: string;
  @Prop({ required: false, default: false }) private idsList: [];
  private data_: HqPackingList;
  private options: HqPackingList;
  private showEdit = false;
  private showHistory = false;
  private currentRow: CustomsPackingSet = new CustomsPackingSet();
  selection: CustomsPackingSet[] = [];
  private queryProductInfoDetailVisible = false;
  private productInfos: ProductInfoDetail[] = [];
  private currentTotalNumberPcs: number;
  private currentCustomsPackingId: string;

  @Watch("data", { deep: true, immediate: true })
  private watchData() {
    this.data_ = this.data;
  }

  @Watch("idsList", { deep: true, immediate: true })
  // private watchIdsList() {

  // }
  private toggleSelection(rows: CustomsPackingSet[]) {
    if (rows) {
      this.$nextTick(() => {
        rows.forEach((row) => {
          (
            this.$refs.multipleTable as Vue & { toggleRowSelection: Function }
          ).toggleRowSelection(row);
        });
      });
    } else {
      this.$nextTick(() => {
        (
          this.$refs.multipleTable as Vue & { clearSelection: Function }
        ).clearSelection();
      });
    }
  }

  private confirmEdit(row: UnpackedProductInfos) {
    this.$emit("edit-product-number", row);
  }

  private handleSelectionChange(rows: CustomsPackingSet[]) {
    this.selection = rows;
  }

  private gotoPackageManagementPage() {
    this.$emit("gotoPackageManagementPage", this.data_.id);
  }

  private checkConfirm() {
    this.showHistory = true;
    // this.$router.push({
    //   name: "QueryCustomsPackingHistoryProblem",
    //   params: { inventoryPlanId: this.data_.id },
    //   query: {
    //     state: JSON.stringify(this.data_.customsPackingSet[0].state),
    //   },
    // });
  }

  // 删除盘库
  private handleDelete(rows: CustomsPackingSet) {
    this.$confirm("是否确认删除？", "警告", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      this.toDelete(rows);
    });
  }
  private async toDelete(rows: CustomsPackingSet) {
   await deleteInventoryPlans(rows.id);
    this.$message({
      type: "success",
      message: "删除成功!",
    });
    this.$emit("refresh");
  }

  private handleEditPackageInfo(rows: CustomsPackingSet) {
    this.currentRow = rows;
    this.showEdit = true;
  }

  private async onDialogConfirmed() {
    this.showEdit = false;
    this.$emit("onDialogConfirmed", this.currentRow);
  }

  private async handleShowProductInfoDetail(currentRowId: string){
    this.productInfos = [];
    await this.getProductList(currentRowId);
    this.queryProductInfoDetailVisible = true;
  }

  private async getProductList(currentRowId: string){
    const data:any = await queryProductInfos(currentRowId);
    this.currentCustomsPackingId = currentRowId;
    this.productInfos = data;
  }

  private async updateProductQuantity(row: any, newQuantity: number){
    this.currentTotalNumberPcs = row.totalNumberPcs;
    await updateProductQuantity(row.id,{quantity:newQuantity});
    await this.getProductList(this.currentCustomsPackingId);
    this.$notify({
      title: "成功",
      message: "更新成功",
      type: "success",
      duration: 2000
    });
    row.popoverVisible = false;
  }
}

export class LoadingPlanListTableRowData {
  id: string;
  code: string;
  createdDate: string;
  containerType: string;
  type: LoadingPlanType;
  category: string;
  loadingPlace: string;
  containerInfo: string;
  totalProductQuantity: number;
  totalAmount: string;
  totalVolume: string;
  select: boolean;

  isMatch(code?: string, category?: string, factoryName?: string): boolean {
    let match = true;
    if (!isEmpty(code)) {
      match = this.code.includes(toUpper(code));
    }
    if (!isEmpty(category)) {
      match = match && this.category === category;
    }
    if (!isEmpty(factoryName)) {
      match = match && this.loadingPlace.includes(factoryName);
    }
    return match;
  }
}

export class ProductInfoDetail {
  id: string;
  description: string;
  declarationDescription: string;
  guestModel: string;
  hqOrJrNumber: string;
  oeNumber: string;
  refNumber: string;
  totalNumberPcs: number;
  purchaseOrderNumber: string;
  popoverVisible: boolean;
}
